import { render, staticRenderFns } from "./deliveryRoutesPage.vue?vue&type=template&id=6ad4dadf&"
import script from "./deliveryRoutesPage.vue?vue&type=script&lang=ts&"
export * from "./deliveryRoutesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports